import { css } from 'styled-components';

import theme from 'styles/token/color';

// 스크롤바 스타일 객체
const scrollbarStyles = {
  default: css`
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: #ccc;
    }
    &::-webkit-scrollbar-track {
      background: #e9ecef;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #c4c6c8;
      cursor: pointer;
    }
  `,
  hover: css`
    scrollbar-gutter: stable;
    overflow-y: hidden;
    transition: background-color 0.3 ease-in-out;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
      background-clip: padding-box;
      border-radius: 8px;

      &:hover {
        background: #c4c6c8;
        cursor: pointer;
      }
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-button {
      display: block;
      height: 12px; /* 상하단 강제 여백 (높이 조절 효과) */
      background: transparent;
    }

    /* 부모 영역(SidebarWrap 등) 호버 시에만 막대 노출 */
    &:hover {
      overflow-y: auto;
      &::-webkit-scrollbar-thumb {
        background-color: ${theme.color.gray100};
      }
    }
  `,
  x: css`
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background: #ccc;
    }
    &::-webkit-scrollbar-track {
      background: #e9ecef;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #c4c6c8;
      cursor: pointer;
    }
  `,
};

const scrollbar = scrollbarStyles.default;
const scrollbarHover = scrollbarStyles.hover;
const scrollbarX = scrollbarStyles.x;

export const scrollBar = {
  default: scrollbar,
  hover: scrollbarHover,
  x: scrollbarX,
};
